import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
// import { Link, graphql, StaticQuery } from 'gatsby'
import { Link } from 'gatsby'
import { connect } from 'react-redux'
import { globalHistory } from '@reach/router'

// const query = graphql`
//   query NavigationQuery {
//     collection: shopifyCollection(handle: {eq: "webstore"}) {
//       products {
//         handle
//       }
//     }
//   }
// `

const navigationItems = [
  {
    label: "Work",
    to: "/work"
  },
  {
    label: "Conversations",
    children: [
      {
        label: "SAJI - Nov 16, 2023, 7:20pm",
        to: "/conversations/saji-11-16-23"
      },
      {
        label: "SAJI - Sep 22, 2025, 5:19pm",
        to: "/conversations/saji-09-22-25"
      }
    ]
  },
  {
    label: "About",
    to: "/about"
  }
]

const NavigationItem = ({ item, isTouch }) => {
  const [isOpen, setIsOpen] = useState(false)

  const hasChildren = !!item.children && item.children.length > 0

  // Listen for URL changes directly in each NavigationItem
  useEffect(() => {
    const unlisten = globalHistory.listen(({ location }) => {
      console.log('location changed - setting close')
      setIsOpen(false)
    })
    
    return unlisten
  }, [isOpen])

  const handleMouseEnter = (e) => {
    if (isTouch) return
    
    setIsOpen(true)
  }
  const handleMouseLeave = (e) => {
    if (isTouch) return
    
    setIsOpen(false)
  }
  const handleToggleClick = (e) => {
    e.preventDefault()
    setIsOpen(!isOpen)
  }
  
  return (
    <li
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {hasChildren ? (
        <>
          <a 
            href="#" 
            aria-label="Toggle submenu" 
            onClick={handleToggleClick}
            aria-expanded={isOpen}
          >
            {item.label}
          </a>
          <ul
            className={`${isOpen ? 'is-open' : ''}`}
            aria-hidden={!isOpen}
          >
            {item.children.map((child, index) => (
              <li key={index}>
                <Link 
                  to={child.to}
                  tabIndex={isOpen ? 0 : -1} // Only tabbable when dropdown is open
                >
                  {child.label}
                </Link>
              </li>
            ))}
          </ul>
        </>
      ) : (
        <Link to={item.to}>{item.label}</Link>
      )}
    </li>
  );
}

const Navigation = ({ data, show, isTouch }) => {
  // const hasProducts = !!(data && data.collection && data.collection.products && data.collection.products.length) 

  return (
    <nav
      role="navigation"
      className={`navigation ${!show ? 'is-hidden' : ''}`}
    >
      <ul>
        {navigationItems.map((item, index) => (
          <NavigationItem key={index} item={item} isTouch={isTouch} />
        ))}
      </ul>
    </nav>
  )
}

Navigation.proptypes = {
  show: PropTypes.bool
}

Navigation.defaultProps = {
  show: true
}

export default connect(state => ({
  isTouch: state.isTouch
}))(Navigation)

// export default props => (
//   <StaticQuery
//     query={query}
//     render={data => <Navigation data={data} {...props} />}
//   />
// )
